<template>
  <div class="about-container" v-loading='loading||iframeLoading'>
    <iframe class="about-iframe" :src="data" frameborder="0" @load='onload'></iframe>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "About",
  data(){
    return {
      iframeLoading: true,
    }
  },
  methods: {
    onload(){
      this.iframeLoading = false
    }
  },
  computed:{
    ...mapState('about',['data','loading'])
  }
};
</script>

<style lang="less">
.about-container{
  width: 100%;
  height: 100%;
  position: relative;
}
.about-iframe{
  height: 100vh;
  width: 100%;
}
</style>
